"use client";

import { useAtomValue, useSetAtom } from "jotai";
import { startTransition, useCallback } from "react";
import { isAdminNavbarOpened, isMobileAtom } from "../../store/layoutStore";
import { sizes } from "../../styles/globalsStyles";
import { userAtom } from "../../store/userAtom";
import Image from "next/image";

const NavbarImage = () => {
  const user = useAtomValue(userAtom);
  const isMobile = useAtomValue(isMobileAtom);

  const setAdminNavbar = useSetAtom(isAdminNavbarOpened);

  const handleClickOnPicture = useCallback(() => {
    if (!user?.isAdmin) return;

    startTransition(() => {
      setAdminNavbar((state) => !state);
    });
  }, [setAdminNavbar, user?.isAdmin]);

  return (
    <Image
      alt="rina styling"
      src="/assets/buisnessLogo.png"
      width={!isMobile ? sizes.navbarHeight : sizes.navbarHeight}
      height={sizes.navbarHeight}
      sizes="100%"
      style={{ cursor: user?.isAdmin ? "pointer" : undefined }}
      onClick={handleClickOnPicture}
    />
  );
};

export default NavbarImage;
